import type {LinkStatus} from 'schemaDefinition/types';
import type {LinkStatusIconStatus} from '../types';

type ResolvableLink = {
  linkStatus: LinkStatus;
  nationalId?: string | null;
  agentVerified?: boolean;
};

export const resolveIconStatus = (
  link: ResolvableLink | undefined,
): LinkStatusIconStatus => {
  const linkStatus = link?.linkStatus ?? 'empty';
  return linkStatus !== 'verified'
    ? linkStatus
    : link?.agentVerified === false
      ? 'verifiedUnchecked'
      : link?.nationalId
        ? 'externalVerified'
        : 'verified';
};
